import { Outlet } from 'react-router'

import { Sidebar } from '@/nexus/components/admin-layout/Sidebar'
import { Topbar } from '@/nexus/components/admin-layout/Topbar'
import { Footer } from '@/nexus/components/admin-layout/Footer'

import { adminMenuItems } from './menu'
import { AnalyticsPeriodProvider } from '@/lib/analytics-period'

/**
 * Nexus admin shell — Sidebar + Topbar + content + Footer, matching the
 * template's #layout-sidebar / #layout-topbar / #layout-content contract
 * (styled by nexus/styles/pages/layout.css). Pages render into <Outlet/>.
 */
export default function AdminLayout() {
  return (
    <AnalyticsPeriodProvider>
      <div className="size-full">
        <div className="flex">
          <Sidebar menuItems={adminMenuItems} />
          <div className="flex h-screen min-w-0 grow flex-col overflow-auto bg-base-100">
            <Topbar />
            <div id="layout-content" className="grow">
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </AnalyticsPeriodProvider>
  )
}
